import { RebrandContext } from 'helpers/contexts/rebrandContext';
import React, { useContext, useEffect } from 'react';

const PageNotFound: React.FC = () => {
  const { setNewUi } = useContext(RebrandContext);

  useEffect(() => {
    setNewUi(true);
  }, [setNewUi]);

  return <div className={`error-page`}>404</div>;
};

export default PageNotFound;
